import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "i18next";

// Plain helper (not a component), so it reads translations off the i18next singleton
// directly. The 2nd arg to t() is the English default — apps without these keys (or
// without i18n) render English unchanged.
const openDeleteModal = (onConfirm) => {
  modals.openConfirmModal({
    title: i18n.t("generic.confirm_title", "Are you sure?"),
    centered: true,
    children: (
      <Text size="sm">
        {i18n.t("generic.action_irreversible", "This action cannot be undone")}
      </Text>
    ),
    labels: {
      confirm: i18n.t("generic.confirm", "Confirm"),
      cancel: i18n.t("generic.cancel", "Cancel"),
    },
    confirmProps: { color: "red" },
    onCancel: () => console.log("Cancel"),
    onConfirm: () => onConfirm(),
  });
};

export default openDeleteModal;
